import { memo } from 'react'

import { AssignmentLate, AssignmentTurnedIn } from '@mui/icons-material'

import { Chip, Tooltip } from '@collaborate-health/uikit'

export interface ArticleReadStatusChipProps {
  read: boolean
}

const ArticleReadStatusChip: React.FC<ArticleReadStatusChipProps> = ({ read }) => {
  return (
    <Tooltip cursor='help' text={read ? 'Read' : 'Unread'}>
      <Chip
        size='small'
        icon={read ? <AssignmentTurnedIn /> : <AssignmentLate />}
        color={read ? 'success' : 'primary'}
        label={read ? 'Read' : 'Unread'}
      />
    </Tooltip>
  )
}

export default memo(ArticleReadStatusChip)

